import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const PressureKpiIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorIcon;

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.3125C13.0386 16.3125 16.3125 13.0386 16.3125 9C16.3125 4.96142 13.0386 1.6875 9 1.6875C4.96142 1.6875 1.6875 4.96142 1.6875 9C1.6875 13.0386 4.96142 16.3125 9 16.3125ZM7.87341 6.32006C8.20272 6.16825 8.55917 6.08415 8.92161 6.07276C9.28405 6.06137 9.64509 6.12292 9.98328 6.25376C10.1493 6.31799 10.3082 6.39828 10.4577 6.49324L9.49331 7.45763C9.33986 7.40017 9.17368 7.36874 9.00017 7.36874C8.22352 7.36874 7.59392 7.99834 7.59392 8.77499C7.59392 9.55164 8.22352 10.1812 9.00017 10.1812C9.77682 10.1812 10.4064 9.55164 10.4064 8.77499C10.4064 8.58581 10.3691 8.40536 10.3013 8.24061L12.4427 6.09924C12.6624 5.87957 12.6624 5.52341 12.4427 5.30374C12.223 5.08407 11.8669 5.08407 11.6472 5.30374L11.2669 5.68405C10.9971 5.487 10.7022 5.32562 10.3892 5.20454C9.91044 5.01932 9.39935 4.93219 8.88628 4.94831C8.3732 4.96444 7.86859 5.08349 7.40242 5.2984C6.93624 5.51331 6.51799 5.8197 6.17252 6.19937C5.82704 6.57905 5.56137 7.02427 5.39129 7.5086C5.2212 7.99294 5.15016 8.50651 5.1824 9.01883C5.21463 9.53114 5.34947 10.0318 5.57892 10.491C5.80837 10.9502 6.12774 11.3586 6.51808 11.6919C6.75431 11.8937 7.10937 11.8658 7.31112 11.6295C7.51288 11.3933 7.48494 11.0383 7.24871 10.8365C6.97297 10.601 6.74736 10.3125 6.58528 9.98811C6.4232 9.66373 6.32795 9.31009 6.30518 8.94819C6.28241 8.58628 6.33259 8.22349 6.45274 7.88136C6.57289 7.53922 6.76056 7.22472 7.0046 6.95651C7.24865 6.68831 7.5441 6.47188 7.87341 6.32006Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default PressureKpiIcon;
